__turbopack_context__.v({
  "disclaimer": "disclaimer-module-scss-module__3xGshG__disclaimer",
  "disclaimerContainer": "disclaimer-module-scss-module__3xGshG__disclaimerContainer",
  "disclaimerDynamicFooter": "disclaimer-module-scss-module__3xGshG__disclaimerDynamicFooter",
  "disclaimerGlobalFooter": "disclaimer-module-scss-module__3xGshG__disclaimerGlobalFooter",
  "disclaimerLogo": "disclaimer-module-scss-module__3xGshG__disclaimerLogo",
  "disclaimerLogos": "disclaimer-module-scss-module__3xGshG__disclaimerLogos",
  "dividerWrapper": "disclaimer-module-scss-module__3xGshG__dividerWrapper",
  "footnoteNumber": "disclaimer-module-scss-module__3xGshG__footnoteNumber",
  "footnotes": "disclaimer-module-scss-module__3xGshG__footnotes",
  "tc": "disclaimer-module-scss-module__3xGshG__tc",
  "ul": "disclaimer-module-scss-module__3xGshG__ul",
  "xRayModeWrapper": "disclaimer-module-scss-module__3xGshG__xRayModeWrapper",
});
